import { useQuery } from "@tanstack/react-query";
import { getLocations } from "@/services/officeService";

export const useOfficeLocations = () => {
  const query = useQuery({
    queryKey: ["office-locations"],
    queryFn: async () => {
      const response = await getLocations();
      // Handle the nested structure: { data: { locations: [...] } } or { locations: [...] }
      const data = response.data || response;
      if (Array.isArray(data)) return data;
      if (data && Array.isArray(data.locations)) return data.locations;
      return [];
    },
    staleTime: 1000 * 60 * 60 // 1 hour
  });

  return {
    locations: query.data || [],
    isLoading: query.isLoading,
    error: query.error
  };
};
